import { FilterConfigPassive } from '@/types/filter';

const insightTagFilter: FilterConfigPassive = {
  label: 'main.insights.filters.labels.tag',
  placeholder: 'main.insights.filters.labels.tag',
  type: 'multiselect',
  defaultValue: [],
  disabled: true,
  options: [],
  useFloatingLabel: true,
  searchable: true,
  clearable: true,
};

export default insightTagFilter;
